<!--  <highcharts-chart 
  [Highcharts]="Highcharts"
  [options]="chartOptions"
  style="width: 100%; height: 400px; display: block;"
></highcharts-chart> -->
 -

<!--  <div [chart]="chart"></div>
 <button (click)="add()">Add Point!</button> -->
<!-- 
 <div id="container1"></div> -->
 <highcharts-chart 
 [Highcharts]="Highcharts"
 [options]="chartOptions"

 style="width: 100%; height: 400px; display: block;"
></highcharts-chart>